export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20atmosphere%20with%20warm%20amber%20spotlight%20rays%20cutting%20through%20subtle%20haze%2C%20abstract%20film%20reel%20textures%20blended%20with%20soft%20geometric%20patterns%2C%20deep%20charcoal%20and%20warm%20bronze%20tones%2C%20elegant%20and%20moody%20cinema%20aesthetic%2C%20no%20text%2C%20artistic%20composition&width=1800&height=900&seq=hero-bg-movie-01&orientation=landscape"
          alt="影院氛围背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-300/30 mb-6">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-fire-line text-accent-500 text-xs"></i>
              </span>
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">周更 · 热门新片速递</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] font-bold text-background-50 leading-tight">
              爱丫爱丫影院
              <br />
              <span className="text-accent-400">高清免费在线观影平台</span>
            </h1>

            <p className="mt-4 text-sm text-white/75 leading-relaxed max-w-lg mx-auto lg:mx-0">
              最新电影在线观看，动作电影、喜剧电影、经典电影大全。本站收录海量高清影片，
              涵盖国内外热门新片与影史佳作，无需下载即可流畅播放。
              每日更新片源，无论您钟情于肾上腺素飙升的动作大片，
              还是偏爱轻松解压的喜剧故事，这里都能找到属于您的光影时刻。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 text-xs text-white/65">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-movie-line text-accent-400"></i>
                </span>
                片源周更 30+
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-400"></i>
                </span>
                极速秒开 · 不缓冲
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-400"></i>
                </span>
                1080P 高清画质
              </span>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </span>
                立即观影
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg border border-background-50/25 hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-grid-line"></i>
                </span>
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20with%20warm%20golden%20and%20amber%20lighting%2C%20abstract%20movie%20elements%20including%20film%20strips%20and%20soft%20lens%20flares%2C%20artistic%20composition%20with%20rich%20textures%20and%20dramatic%20shadows%2C%20elegant%20cinema%20aesthetic%20with%20bronze%20and%20charcoal%20accents%2C%20no%20human%20faces%2C%20abstract%20and%20atmospheric&width=960&height=720&seq=hero-visual-movie-02&orientation=landscape"
                alt="爱丫爱丫影院主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-900/20 via-transparent to-accent-500/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}